import { alpha, Theme } from '@mui/material';
import { useBlendColors } from 'hooks/useDesign';

export default {
    listItemsBlock: {
        position: 'relative',
        border: '1px solid',
        borderColor: 'primary.main',
        borderRadius: '4px',
        backgroundColor: 'background.default',
        boxShadow: (theme: Theme) => `0px 4px 20px 0px ${alpha(theme.palette.primary.main, 0.24)}`,
        'body:not(.isDragActive) .sort-list-holder &:not(:hover), body.isDragActive .sort-list-holder &': {
            borderColor: (theme: Theme) => useBlendColors(alpha(theme.palette.text.primary, 0.16)),
        },
        '.sort-list-holder &': {
            boxShadow: 'none',
        },
    },
    listItemsWrapper: {
        flexGrow: 1,
        width: '100%',
        boxShadow: 'none',
        padding: '4px 8px 8px 0',
        minWidth: 0,
    },
    dragAndDropWrapper: {
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
        padding: '0 12px',
    },
    deleteItemWrapper: {
        boxShadow: 'none',
        position: 'absolute',
        left: '100%',
        top: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '8px',
        'body:not(.isDragActive) .sort-list-holder .list-item-wrapper:not(:hover) &, body.isDragActive .sort-list-holder &':
            {
                display: 'none',
            },
    },
    dragAndDropIcon: {
        fontSize: '16px',
        cursor: 'row-resize',
        color: 'primary.main',
        'body:not(.isDragActive) .sort-list-holder .list-item-wrapper &:not(:hover), body.isDragActive .sort-list-holder &':
            {
                color: 'text.primary',
            },
    },
    deleteButton: {
        backgroundColor: (theme: Theme) => alpha(theme.palette.error.main, 0.08),
        color: (theme: Theme) => alpha(theme.palette.error.main, 0.8),
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 1,
        minWidth: (theme: Theme) => theme.size.defaultHeight,
        minHeight: (theme: Theme) => theme.size.defaultHeight,
        '&:hover': {
            backgroundColor: (theme: Theme) => alpha(theme.palette.error.main, 0.16),
            color: (theme: Theme) => theme.palette.error.main,
        },
    },
};
